import React from 'react'
import BreadCrumbs from '../BreadCrumbs/breadcrumbs'
import YoutubePlayer from '../YoutubePlayer/youtube-player'

import { parseUrlParameters } from '../../util'

import PlayIcon from '../../assets/icons/play-icon'
import './hero-sub.scss'



class HeroSub extends React.Component {
  constructor(props) {
    super(props)

    this.mediaContainer = React.createRef()
    this.onClick = this.onClick.bind(this)
    this.closeVideo = this.closeVideo.bind(this)

    this.state = {
      playVideo: false
    }
  }

  onClick() {
    this.setState({
      playVideo: true
    })
  }

  closeVideo() {
    this.setState({
      playVideo: false
    })
  }

  renderVideoControls(image, localization) {
    if (!image) {
      return null
    }
  
    const heading = image.description || image.title
    return (
      <div className="video-controls-container">
        <div className="description">
          <h2>{ heading }</h2>
        </div>
        <button className="btn primary play-button" onClick={ this.onClick }>{ localization('global.watchVideo') } <PlayIcon /></button>
      </div>
    )
  }

  render() {
    const { content, lang, localization } = this.props

    if (!content) {
      return null
    }
  
    const backgroundColor = content.backgroundColor || '#F8D4D2'
    const alignSubheroImage = content.alignSubheroImage ? content.alignSubheroImage : 'top'
    const { src, srcSet } =  content.background && content.background.sizes ? content.background.sizes : { src: '', srcSet: '' }
    const videoControls = content.videoUrl ? this.renderVideoControls(content.background, localization) : null
    const videoHeight = this.mediaContainer.current ? this.mediaContainer.current.clientHeight : '100%'
    const videoPlayer = content.videoUrl && parseUrlParameters(content.videoUrl).v ? 
      <YoutubePlayer url={content.videoUrl} play={this.state.playVideo} height={videoHeight} closeVideo={ this.closeVideo } localization={localization}/> : null

    return (
      <div className="subhero-container">

        {content.background && !content.videoUrl ? <div className={`image-container`}>
          <img src={ src } srcSet={ srcSet } className={`hero-image ${alignSubheroImage}`} alt="" />
        </div> : null }

        {content.background && content.videoUrl ? <div className={`media-backdrop`} style={{ backgroundColor }}></div> : null}
        {content.background && content.videoUrl ? <div className={`media-container`} ref={ this.mediaContainer }>
          { videoControls }
          { videoPlayer }
          <img src={ src } srcSet={ srcSet } className={`media-image`} alt="" />
          
        </div> : null }

        <BreadCrumbs lang={ lang } localization={ localization} />
        
        { content.heading ? <h1 className="subhero-heading">{ content.heading }</h1> : null }
  
        { content.body ? <div className="subhero-content"  dangerouslySetInnerHTML={{__html:content.body.body}}></div> : null  }
      </div>
    )
  }
}

export default HeroSub



// WEBPACK FOOTER //
// ./src/components/Hero/hero-sub.js